import { useEffect } from "react";

export const useSEO = ({ title, description, path, jsonLd }) => {
  useEffect(() => {
    document.title = title;
    const set = (selector, attr, value) => {
      const el = document.head.querySelector(selector);
      if (el) el.setAttribute(attr, value);
    };
    set('meta[name="description"]', "content", description);
    set('link[rel="canonical"]', "href", `https://fixromah24.com${path}`);
    set('meta[property="og:title"]', "content", title);
    set('meta[property="og:description"]', "content", description);
    set('meta[property="og:url"]', "content", `https://fixromah24.com${path}`);
    set('meta[name="twitter:title"]', "content", title);
    set('meta[name="twitter:description"]', "content", description);

    let script = null;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    window.scrollTo(0, 0);
    return () => {
      if (script) script.remove();
    };
  }, [title, description, path]);
};
